import _ from 'lodash';
import { DEFAULT_HEADLINE_VIZ_PROPERTY, } from '../client-state-type';
export function applyHeadlineVisualOverrides(vizModel) {
    var _a;
    const vizProps = vizModel.vizProps;
    const visualOverrides = vizModel.visualOverrides;
    if (_.isNil(visualOverrides)) {
        return vizProps;
    }
    const columnPropertyOverrides = (_a = visualOverrides === null || visualOverrides === void 0 ? void 0 : visualOverrides.overrides) === null || _a === void 0 ? void 0 : _a.columnProperty;
    if (!columnPropertyOverrides) {
        return vizProps;
    }
    const updatedHeadlineColumnProperty = {
        ...DEFAULT_HEADLINE_VIZ_PROPERTY,
        ...vizProps === null || vizProps === void 0 ? void 0 : vizProps.columnProperty,
    };
    if (!_.isNil(columnPropertyOverrides.summariesNumberFormatConfig)) {
        updatedHeadlineColumnProperty.summariesNumberFormatConfig =
            columnPropertyOverrides.summariesNumberFormatConfig;
    }
    if (!_.isNil(columnPropertyOverrides.conditionalFormatting)) {
        updatedHeadlineColumnProperty.conditionalFormatting =
            columnPropertyOverrides.conditionalFormatting;
    }
    return {
        ...vizProps,
        columnProperty: updatedHeadlineColumnProperty,
    };
}
//# sourceMappingURL=headline-overrides-util.js.map